module.exports = __webpack_public_path__ + "media/images/new_home/1-janique-edwards-aedd7e03454cc471749647ca68c4a6c3.png";